import { ErrorCard } from '#/shared/components/ErrorCard';
import { Container } from '#/shared/components/layout/Container';
import type { PageState } from '#/shared/types/PageState';

interface ErrorScreenProps {
  pageState: PageState;
  errorCode?: number;
}

export function ErrorScreen({ pageState, errorCode }: Readonly<ErrorScreenProps>) {
  const showTimesheetUnavailableError =
    pageState === 'invalid-token' || (pageState === 'loading-error' && (errorCode === 400 || errorCode === 401));

  return (
    <Container className="flex flex-1 flex-col items-center justify-center space-y-4">
      {showTimesheetUnavailableError ? (
        <ErrorCard
          title="Timesheet unavailable"
          description="The link may be incorrect, or the timesheet approval request may have been completed or canceled. If needed, the requestor will send a new request."
        />
      ) : (
        <ErrorCard showIcon />
      )}
    </Container>
  );
}
